// extracted by mini-css-extract-plugin
export default {"checkBox":"styles_checkBox__9MNry"};